import { Agent_SortOrder } from '@/graphql/codegen/generated/graphql';

export const WINDOWS_HEADERS = [
  { minWidth: 197, name: 'Name', sortable: true, defaultSortOrder: Agent_SortOrder.Ascending },
  { minWidth: 197, name: 'Assigned Agents', sortable: true, defaultSortOrder: Agent_SortOrder.Descending },
  { minWidth: 197, name: 'Cloud Agents', sortable: true, defaultSortOrder: Agent_SortOrder.Ascending },
];

export const WINDOWS_HEADERS_WITHOUT_CLOUD = [
  { minWidth: 296, name: 'Name', sortable: true, defaultSortOrder: Agent_SortOrder.Ascending },
  { minWidth: 296, name: 'Assigned Agents', sortable: true, defaultSortOrder: Agent_SortOrder.Descending },
];

export const LINUX_HEADERS = [{ minWidth: 296, name: 'Name', sortable: true, defaultSortOrder: Agent_SortOrder.Ascending }];
